var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5013 0C3.76492 0 3.16797 0.596954 3.16797 1.33333C3.16797 2.06971 3.76492 2.66667 4.5013 2.66667H4.94575V8.08715C3.92072 8.37006 3.16797 9.30924 3.16797 10.4242C3.16797 10.5581 3.27651 10.6667 3.41039 10.6667H4.94575H7.61241V15.1111C7.61241 15.602 8.01038 16 8.5013 16C8.99222 16 9.39019 15.602 9.39019 15.1111V10.6667H12.0569H13.5922C13.7261 10.6667 13.8346 10.5581 13.8346 10.4242C13.8346 9.30924 13.0819 8.37006 12.0569 8.08715V2.66667H12.5013C13.2377 2.66667 13.8346 2.06971 13.8346 1.33333C13.8346 0.596954 13.2377 0 12.5013 0H12.0569H4.94575H4.5013Z",
    fill: "#1D2933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.6117ad6bcbb1b8832779e7f943db4474.svg";
export { ForwardRef as ReactComponent };